/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  ModelloGatewayDto,
  ModelloGatewayUpdateDtoInt32EntityChange,
  ModelloGatewayCreateDto,
  ModelloGatewayUpdateDto,
} from ".././models";

export const getModelliGateway = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ModelloGatewayDto[]>> => {
  return axios.get(`/api/modelliGateway`, options);
};

export const getGetModelliGatewayQueryKey = () =>
  [`/api/modelliGateway`] as const;

export const getGetModelliGatewayQueryOptions = <
  TData = Awaited<ReturnType<typeof getModelliGateway>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getModelliGateway>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getModelliGateway>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModelliGatewayQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModelliGateway>>
  > = ({ signal }) => getModelliGateway({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetModelliGatewayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModelliGateway>>
>;
export type GetModelliGatewayQueryError = AxiosError<unknown>;

export const useGetModelliGateway = <
  TData = Awaited<ReturnType<typeof getModelliGateway>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getModelliGateway>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetModelliGatewayQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateModelliGateway = (
  modelloGatewayUpdateDtoInt32EntityChange: ModelloGatewayUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.patch(
    `/api/modelliGateway`,
    modelloGatewayUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateModelliGatewayMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelliGateway>>,
    TError,
    { data: ModelloGatewayUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModelliGateway>>,
  TError,
  { data: ModelloGatewayUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModelliGateway>>,
    { data: ModelloGatewayUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { data } = props ?? {};

    return updateModelliGateway(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelliGatewayMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModelliGateway>>
>;
export type UpdateModelliGatewayMutationBody =
  ModelloGatewayUpdateDtoInt32EntityChange[];
export type UpdateModelliGatewayMutationError = AxiosError<unknown>;

export const useUpdateModelliGateway = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelliGateway>>,
    TError,
    { data: ModelloGatewayUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateModelliGatewayMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createModelloGateway = (
  modelloGatewayCreateDto: ModelloGatewayCreateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ModelloGatewayDto>> => {
  return axios.post(`/api/modelliGateway`, modelloGatewayCreateDto, options);
};

export const getCreateModelloGatewayMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelloGateway>>,
    TError,
    { data: ModelloGatewayCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModelloGateway>>,
  TError,
  { data: ModelloGatewayCreateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModelloGateway>>,
    { data: ModelloGatewayCreateDto }
  > = (props) => {
    const { data } = props ?? {};

    return createModelloGateway(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModelloGatewayMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModelloGateway>>
>;
export type CreateModelloGatewayMutationBody = ModelloGatewayCreateDto;
export type CreateModelloGatewayMutationError = AxiosError<unknown>;

export const useCreateModelloGateway = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModelloGateway>>,
    TError,
    { data: ModelloGatewayCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getCreateModelloGatewayMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateModelloGateway = (
  id: number,
  modelloGatewayUpdateDto: ModelloGatewayUpdateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ModelloGatewayDto>> => {
  return axios.put(
    `/api/modelliGateway/${id}`,
    modelloGatewayUpdateDto,
    options
  );
};

export const getUpdateModelloGatewayMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelloGateway>>,
    TError,
    { id: number; data: ModelloGatewayUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModelloGateway>>,
  TError,
  { id: number; data: ModelloGatewayUpdateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModelloGateway>>,
    { id: number; data: ModelloGatewayUpdateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateModelloGateway(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModelloGatewayMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModelloGateway>>
>;
export type UpdateModelloGatewayMutationBody = ModelloGatewayUpdateDto;
export type UpdateModelloGatewayMutationError = AxiosError<unknown>;

export const useUpdateModelloGateway = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModelloGateway>>,
    TError,
    { id: number; data: ModelloGatewayUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateModelloGatewayMutationOptions(options);

  return useMutation(mutationOptions);
};

export const __$$useGetModelliGateway = () =>
  //@ts-ignore
  useGetModelliGateway(...([] as any[]));

export const __$$useUpdateModelliGateway = () =>
  //@ts-ignore
  useUpdateModelliGateway(...([] as any[]));

export const __$$useCreateModelloGateway = () =>
  //@ts-ignore
  useCreateModelloGateway(...([] as any[]));

export const __$$useUpdateModelloGateway = () =>
  //@ts-ignore
  useUpdateModelloGateway(...([] as any[]));
